import { clientConfig } from '@/config/clientConfig';
import { useAuthStore } from '@/domains/auth';
import { useEffect, useRef } from 'react';

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart', 'pointermove'] as const;

export function useInactivityTimeout() {
  const { isAuthenticated, logout } = useAuthStore();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const timeoutMinutes = clientConfig.features.inactivityTimeoutMinutes;

  useEffect(() => {
    if (!timeoutMinutes || !isAuthenticated) return;

    const timeoutMs = timeoutMinutes * 60 * 1000;

    const resetTimer = () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        logout();
        window.location.href = '/login?reason=timeout';
      }, timeoutMs);
    };

    resetTimer();

    for (const event of ACTIVITY_EVENTS) {
      window.addEventListener(event, resetTimer, { passive: true });
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      for (const event of ACTIVITY_EVENTS) {
        window.removeEventListener(event, resetTimer);
      }
    };
  }, [timeoutMinutes, isAuthenticated, logout]);
}
